const axios = require('axios');

(() => {
  const paymentButton = '.create-payment-button'

  const init = () => {
    $('body').on('click', paymentButton, createPayment).
      on('change', '.js-card-holder-name', changeHolderName)
  }

  const changeHolderName = e => {
    $(e.currentTarget).val($(e.currentTarget).val().toUpperCase())
  }

  const createPayment = async e => {
    e.preventDefault();
    $(paymentButton).addClass('disabled').prop('disabled', true);
    const reservationType = $(e.currentTarget).data('reservation-type');
    const response = await fetchPaymentMethod(reservationType);

    const paymentMethod = response.data.payment_method;
    const firstPayment = response.data.first_payment;

    switch (paymentMethod) {
      case 'creditcard':
        handleGmoCreditCard();
        break;
      case 'registered_creditcard':
        handleGmoRegisteredCreditCard(reservationType, firstPayment);
        break;
      case 'bank_transfer':
        handleGmoBankTransfer(reservationType, firstPayment);
        break;
      case 'none':
        handleNonePayment(reservationType)
        break;
      default:
        handleGmoPayService(reservationType, paymentMethod, firstPayment);
    }
  }

  const fetchPaymentMethod = async (reservationType) => {
    try {
      return await axios.get(process.env.JS_BASE_URL + 'api/v1/payment_methods?reservation_type=' + reservationType);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchCreditCardInfo = async () => {
    try {
      return await axios.get(process.env.JS_BASE_URL + 'api/v1/credit_card_sessions');
    } catch (error) {
      console.log(error);
    }
  }
  const handleNonePayment = (reservationType) => {

    if (reservationType == 'camping') {
      var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete'
    } else if (reservationType === 'event') {
      var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete'
    } else {
      var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete'
    }

    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.post(targetUrl).then(response => {
      if (response.status === 200) {
        window.location.href = targetUrl;
      }
    }).catch((error) => {
      $(paymentButton).removeClass('disabled').prop('disabled', false);
      if (error.response.data.type == 'AreaCapacityError') {
        alert('お客さまの予約中にほかのお客さまから予約があったため、この日付の在庫がなくなりました。大変お手数ですが、別の日付を選択し、再度お申し込みください。');
      } else {
        alert('決済に失敗しました。再度お試し下さい。');
      }
    });
  }

  const handleGmoCreditCard = async () => {
    const response = await fetchCreditCardInfo();
    const holderName = response.data.holder_name;
    const cardNumber = response.data.card_number;
    const cardNumberString = String(cardNumber);
    const ExpirationMonth = response.data.card_expiration_month;
    const ExpirationYear = response.data.card_expiration_year;
    const securityCode = response.data.security_code;
    const securityCodeString = String(securityCode);
    const additionalCharge = response.data.additional_charge;
    const twoDigitExpirationMonth = ('0' + ExpirationMonth).slice(-2)
    const reservationType = response.data.reservation_type;
    const firstPayment = response.data.first_payment;
    let expireMmyy = String(ExpirationYear) + String(twoDigitExpirationMonth);

    var gmoShopId = gon.gmo_shop_id;
    Multipayment.init(gmoShopId);
    Multipayment.getToken({
      cardno : cardNumberString,
      expire : expireMmyy,
      securitycode : securityCodeString,
      holdername : holderName,
    }, (response) => {
      if (response.resultCode != '000') {
        $(paymentButton).removeClass('disabled').prop('disabled', false);
        alert('クレジットカードが無効です');
      } else {
        let token = response.tokenObject.token;
        var targetUrl;

        if (firstPayment === true) {
          switch (reservationType) {
            case 'event':
              var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete'
              break;
            case 'barbecue':
              var targetUrl = process.env.JS_BASE_URL + 'customer/barbecue/reservation_complete'
              break;
            case 'camping':
              var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete'
              break;
            case 'day_camping':
              var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete'
              break;
          }
        } else {
          switch (reservationType) {
            case 'event':
              var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/payment_complete';
              break;
            case 'barbecue':
              var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/payment_complete';
              break;
            case 'camping':
              var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/payment_complete';
              break;
            case 'day_camping':
              var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/payment_complete';
              break;
          }
        }

        axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
        axios.post(targetUrl, {
          payment_token: token
        }).then(response => {
          if (response.status === 200) {
            window.location.href = targetUrl;
          }
        }).catch((error) => {
          $(paymentButton).removeClass('disabled').prop('disabled', false);
          if (error.response.data.type == 'AreaCapacityError') {
            alert('お客さまの予約中にほかのお客さまから予約があったため、この日付の在庫がなくなりました。大変お手数ですが、別の日付を選択し、再度お申し込みください。');
          } else {
            alert('決済に失敗しました。再度お試し下さい。');
          }
        });
      }
    })
  }

  const handleGmoBankTransfer = async (reservationType, firstPayment) => {
    if (firstPayment === true) {
      switch (reservationType) {
        case 'event':
          var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete'
          break;
        case 'barbecue':
          var targetUrl = process.env.JS_BASE_URL + 'customer/barbecue/reservation_complete'
          break;
        case 'camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete'
          break;
        case 'day_camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete'
          break;
      }
    } else {
      switch (reservationType) {
        case 'event':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/payment_complete';
          break;
        case 'barbecue':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/payment_complete';
          break;
        case 'camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/payment_complete';
          break;
        case 'day_camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/payment_complete';
          break;
      }
    }

    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.post(targetUrl, {
      payment_token: 'fa'
    }).then(response => {
      if (response.status === 200) {
        window.location.href = targetUrl;
      }
    }).catch((error) => {
      $(paymentButton).removeClass('disabled').prop('disabled', false);
      if (error.response.data.type == 'AreaCapacityError') {
        alert('お客さまの予約中にほかのお客さまから予約があったため、この日付の在庫がなくなりました。大変お手数ですが、別の日付を選択し、再度お申し込みください。');
      } else {
        alert('決済に失敗しました。再度お試し下さい。');
      }
    });
  }

  const handleGmoPayService = async (reservationType, paymentMethod, firstPayment) => {
    if (firstPayment === true) {
      switch (reservationType) {
        case 'event':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete/pay_transfer'
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete'
          }
          break;
        case 'barbecue':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/barbecue/reservation_complete/pay_transfer'
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/barbecue/reservation_complete'
          }
          break;
        case 'camping':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete/pay_transfer'
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete'
          }
          break;
        case 'day_camping':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete/pay_transfer'
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete'
          }
          break;
      }
    } else {
      switch (reservationType) {
        case 'event':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/payment_complete/pay_transfer';
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/payment_complete';
          }
          break;
        case 'barbecue':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/payment_complete/pay_transfer';
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/payment_complete';
          }
          break;
        case 'camping':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/payment_complete/pay_transfer';
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/payment_complete';
          }
          break;
        case 'day_camping':
          if (paymentMethod == 'amazonpay' || paymentMethod == 'paypay' || paymentMethod == 'linepay' || paymentMethod == 'merpay') {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/payment_complete/pay_transfer';
          }
          else {
            var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/payment_complete';
          }
          break;
      }
    }

    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: targetUrl,
      method: 'POST',
      data: { payment_token: 'fa'},
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    }).then(response => {
      if (response.status === 200) {
        var url = response.request.responseURL;
        var paymentId = response.data['payment_id']

        switch (paymentMethod) {
          case 'amazonpay':
            window.location.href = process.env.JS_BASE_URL + 'customer/amazonpay_redirect_pages/' + paymentId;
            break;
          case 'paypay':
            window.location.href = process.env.JS_BASE_URL + 'customer/paypay_redirect_pages/' + paymentId;
            break;
          case 'linepay':
            window.location.href = process.env.JS_BASE_URL + 'customer/linepay_redirect_pages/' + paymentId;
            break;
          case 'merpay':
            window.location.href = process.env.JS_BASE_URL + 'customer/merpay_redirect_pages/' + paymentId;
            break;
        }
      }
    }).catch((error) => {
      $(paymentButton).removeClass('disabled').prop('disabled', false);
      if (error.response.data.type == 'AreaCapacityError') {
        alert('お客さまの予約中にほかのお客さまから予約があったため、この日付の在庫がなくなりました。大変お手数ですが、別の日付を選択し、再度お申し込みください。');
      } else {
        alert('決済に失敗しました。再度お試し下さい。');
      }
    });
  }

  const handleGmoRegisteredCreditCard = (reservationType, firstPayment) => {
    var targetUrl;
    var token = 'fafafde';
    if (firstPayment === true) {
      switch (reservationType) {
        case 'event':
          var targetUrl = process.env.JS_BASE_URL + 'customer/event/reservation_complete'
          break;
        case 'barbecue':
          var targetUrl = process.env.JS_BASE_URL + 'customer/barbecue/reservation_complete'
          break;
        case 'camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/camping/reservation_complete'
          break;
        case 'day_camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/day_camping/reservation_complete'
          break;
      }
    } else {
      switch (reservationType) {
        case 'event':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/payment_complete';
          break;
        case 'barbecue':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/payment_complete';
          break;
        case 'camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/payment_complete';
          break;
        case 'day_camping':
          var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/payment_complete';
          break;
      }
    }

    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.post(targetUrl, {
      payment_token: token
    }).then(response => {
      if (response.status === 200) {
        window.location.href = targetUrl;
      }
    }).catch((error) => {
      $(paymentButton).removeClass('disabled').prop('disabled', false);
      alert('決済に失敗しました。再度お試し下さい');
    });
  }
  $(init);
})();

